import Undo from 'undo.js';

export class RemoveFeaturesCommand extends Undo.Command {

  constructor (layer, features) {
    super();
    this.layer = layer;
    this.features = Array.from(features);
  }

  execute () {
    // do nothing
  }

  redo () {
    this.layer.unselectAllFeatures();
    this.layer.removeFeatures(this.features);
  }

  undo () {
    this.layer.addFeatures(this.features);
    this.layer.selectFeatures(this.features);
  }

}
